import Button from '@/components/Button';
import { ButtonVariant } from '@/components/ButtonVariant';
import Countdown from '@/components/Countdown';
import LinkWrapper from '@/components/LinkWrapper';
import Logo from '@/components/Logo';
import { LogoVariant } from '@/components/LogoVariant';
import {
  getCurrentLottoCountdown,
  LottoCountdownType,
} from '@/helpers/getCurrentLottoCountdown';
import { getGameById } from '@/helpers/getGameById';
import { getNow } from '@/utilities/dateUtils';
import { useSyncExternalStore } from 'react';

const noopSubscribe = () => () => {};

let cachedCountdown: LottoCountdownType | undefined;
let cachedLiveMillis: number | null = null;

function getCountdownSnapshot(): LottoCountdownType | undefined {
  const countdown = getCurrentLottoCountdown();
  const liveMillis = countdown ? countdown.live.toMillis() : null;
  if (liveMillis !== cachedLiveMillis) {
    cachedLiveMillis = liveMillis;
    cachedCountdown = countdown ?? undefined;
  }
  return cachedCountdown;
}

export default function LiveTeaser() {
  const countdown = useSyncExternalStore<LottoCountdownType | undefined>(
    noopSubscribe,
    getCountdownSnapshot,
    () => undefined,
  );

  const countdownEnd = countdown ? countdown.live : null;
  const config = getGameById(4);
  const href = config ? config.urls.live || '#' : '#';
  const buttonText = countdownEnd
    ? countdownEnd.toMillis() <= getNow().toMillis()
      ? 'Jetzt ansehen'
      : 'Zur LIVE-Ziehung'
    : 'Jetzt ansehen';

  return (
    <LinkWrapper className="LiveTeaser" href={href}>
      <div className="LiveTeaser__content">
        <Logo
          variant={LogoVariant.Lotto6aus49}
          className="LiveTeaser__logo"
          title="LOTTO 6aus49"
        />
        <strong className="LiveTeaser__title">
          Die LIVE-Ziehung beginnt in:
        </strong>
        <Countdown
          className="LiveTeaser__countdown"
          end={countdownEnd}
          hideHours={true}
        />
        <Button className="LiveTeaser__button" variant={ButtonVariant.Primary}>
          <span>{buttonText}</span>
        </Button>
      </div>
    </LinkWrapper>
  );
}
